import { useEffect, useState } from "react";

export const MotivosServicioSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-motivo"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CC">Consolidado</option>
      <option value="PS">Precio de servicio</option>
      <option value="DC">Disponibilidad de crédito</option>
      <option value="AB">Atención brindada</option>
      <option value="NN">No se necesitó</option>
    </select>
  );
};
